var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as Long from "long";
import { selectBalancingOutskirtUnlockLevel } from "../balancingSelectors/selectBalancingOutskirts";
import { selectBalancingRandomPool } from "../balancingSelectors/selectBalancingRandomPools";
import { selectResourceAmountInfo } from "../balancingSelectors/selectBalancingResources";
import { IdOutskirtBuildings } from "../constants/IdOutskirtBuildings";
import { IdResource } from "../constants/IdResource";
import { LimitedActionType } from "../utils/network/generated/protoTypes";
import { utilLimitedActionTime } from "../utils/utilLimitedActionTime";
import { utilNumber } from "../utils/utilNumber";
import { selectInventoryResourceInfo } from "./selectInventoryInfo";
import { selectLimitedActionInfo } from "./selectLimitedActionInfo";
import { selectOutskirtBuildingInfo } from "./selectOutskirtBuildingInfo";
import { selectPlayerLevel } from "./selectPlayerLevelInfo";
import { selectResourceData } from "./selectResourceInfo";
export var selectDoghouseInfo = function (state) {
    var premiumTreatInfo = selectInventoryResourceInfo(state, IdResource.DogtreatPremium);
    var freeTreatInfo = selectInventoryResourceInfo(state, IdResource.DogtreatStandard);
    var doghouseInfo = selectOutskirtBuildingInfo(state, IdOutskirtBuildings.Doghouse);
    var limitedActionInfo = selectLimitedActionInfo(state, LimitedActionType.DOGHOUSE);
    var freeTreatsGiven = doghouseInfo.proto && doghouseInfo.proto.amount ? doghouseInfo.proto.amount : 0;
    return {
        freeTreatInventoryCount: freeTreatInfo.amount,
        freeTreatsGiven: freeTreatsGiven,
        premiumTreatInventoryCount: premiumTreatInfo.amount,
        secondsLeftForFreeTreatReset: utilLimitedActionTime.getLimitedActionResetRemainingTime(limitedActionInfo),
    };
};
export var selectIsQualifiedForDoghouse = function (state) {
    var level = selectPlayerLevel(state);
    return level >= selectBalancingOutskirtUnlockLevel(IdOutskirtBuildings.Doghouse);
};
export var selectRewardsListPoolContentResources = function (state, poolId) {
    var randomPools = selectBalancingRandomPool(poolId);
    if (!randomPools || !randomPools.poolContent) {
        return [];
    }
    var totalWeight = randomPools.poolContent.reduce(function (acc, val) { return acc + val.weight; }, 0);
    var resourceIdDropPercentageMap = new Map();
    randomPools.poolContent.forEach(function (poolContent) {
        if (!poolContent.resourceReward) {
            return;
        }
        poolContent.resourceReward.forEach(function (_a) {
            var resourceId = _a.resourceId;
            var dropPercentage = utilNumber.roundToPrecision((poolContent.weight / totalWeight) * 100, 1);
            if (resourceIdDropPercentageMap.has(resourceId)) {
                var existingDropPercentage = resourceIdDropPercentageMap.get(resourceId);
                dropPercentage += existingDropPercentage;
            }
            resourceIdDropPercentageMap.set(resourceId, dropPercentage);
        });
    });
    var rewardsList = [];
    resourceIdDropPercentageMap.forEach(function (dropPercentage, key) {
        rewardsList.push(__assign({}, selectResourceData(state, key), { dropPercentage: dropPercentage }));
    });
    return rewardsList;
};
export var selectDogTreatReward = function (state) {
    var grantRewards = state.grantRewards.rewards;
    var resourceReward = grantRewards.resourceRewards
        ? grantRewards.resourceRewards[0] || {}
        : {};
    var reward = selectResourceAmountInfo(resourceReward.typeId, resourceReward.amount);
    return {
        reward: reward,
    };
};
export var selectIsFreeDogTreatAvailable = function (state) {
    var limitedActionInfo = selectLimitedActionInfo(state, LimitedActionType.DOGHOUSE);
    var secondsLeft = utilLimitedActionTime.getLimitedActionResetRemainingTime(limitedActionInfo);
    return secondsLeft <= 0;
};
export var selectIsDogTreatAvailable = function (state) {
    var isFreeTreatAvailable = selectIsFreeDogTreatAvailable(state);
    var standardAmount = selectInventoryResourceInfo(state, IdResource.DogtreatStandard).amount;
    var premiumAmount = selectInventoryResourceInfo(state, IdResource.DogtreatPremium).amount;
    var hasStandardDogTreat = Long.ZERO.lessThan(standardAmount || 0);
    var hasPremiumDogTreat = Long.ZERO.lessThan(premiumAmount || 0);
    return isFreeTreatAvailable || hasPremiumDogTreat || hasStandardDogTreat;
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectDoghouseInfo.ts
// module id = 213
// module chunks = 3